import { useSharedProjectPriceQuery } from "shared/api/price/queries.generated"

export function useSharedProjectPrice({
  shareID,
  skip
}: {
  shareID: string
  skip?: boolean
}) {
  const { data, loading, error } = useSharedProjectPriceQuery({
    variables: { id: shareID },
    skip
  })

  return {
    price: data?.sharedProjectPrice,
    isLoading: loading,
    error
  }
}
